import React from "react";
import "react-loading-skeleton/dist/skeleton.css";
import How from "./how";

function CardFavoris(props) {
 // console.log("props",props)
  return (
    <div className="card-wrapper pointer h-100 d-flex flex-column" onClick={props?.onClick}>
      {/* Image section with fixed height */}
      <div className="image-container h-190 position-relative">
        <img
          src={
            props?.photos?.[0]?.url_photo
              ? process.env.REACT_APP_FILE_URL + props?.photos[0].url_photo
              : "/images/imageFavoris.svg"
          }
          className="card-image w-100 h-100 object-fit-cover"
          alt="Favoris"
        />
        <div className="icon-container inset-0 justify-end items-start p-3 space-x-2 z-10">
          <button className="icon-button" onClick={props?.onAddToFavorites}>
            {props?.pic}
          </button>
          {props?.iconImmediat && props?.iconImmediat == 1 ? (
            <button className="icon-button ">
              <img
                src="/images/share.svg"
                className=""
                alt="Share"
                size="100"
              />
            </button>
          ) : (
            ""
          )}
        </div>
      </div>

      {/* Content section with consistent spacing */}
      <div className={`${props?.bg ? 'gray-Bg' : ''} mt-12 flex-grow-1 d-flex flex-column`}>
        {/* Title and rating row */}
        <div className="d-flex justify-content-between align-items-center mb-2" style={{ minHeight: '40px' }}>
          <h6 className="grey500 m-0 text-truncate pe-2" style={{ maxWidth: '60%' }}>
            {props?.name}
          </h6>
          <span className="card-rating grayCardDetails" style={{ display: 'inline-flex', alignItems: 'center', whiteSpace: 'nowrap' }}>
            <img src="/images/star.svg" alt="Rating" />
            {props?.rating} <span className="card-reviews body">({props?.reviews} avis)</span>
          </span>
        </div>

        {/* Profession */}
        <div className="body grayCardDetails mb-2 text-truncate">
          {props?.profession || ' '}
        </div>

        {/* Address */}
        <div className="legend grayCardDetails mb-3 text-truncate">
          {props?.address || ' '}
        </div>

        {/* Services - ensure consistent height even when empty */}
        <div className="card-services grayCardDetails mt-auto mt-8">
          <div className="d-flex gap-2">
            <How from="type" lieu_intervention={props?.services} />
           
          </div>
        </div>
      </div>
    </div>
  );
}

export default CardFavoris;